function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { MousePositionedTooltip } from '@keen.io/ui-core';
import { AppContext } from '../../contexts';
import SettingsContainer from '../SettingsContainer';
import { FormatNumericSettings, FormatTableSettings } from './components';

var FormatSettings = function FormatSettings(_ref) {
  var widgetType = _ref.widgetType,
      chartSettings = _ref.chartSettings,
      _onUpdateFormatValue = _ref.onUpdateFormatValue,
      formattingDisabled = _ref.formattingDisabled,
      formattingNotAvailable = _ref.formattingNotAvailable,
      onUpdateColumnNamesMapping = _ref.onUpdateColumnNamesMapping;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var onColumnFormatUpdate = function onColumnFormatUpdate(settings) {
    var tableColumnsFormats = _objectSpread(_objectSpread({}, chartSettings.formatTableColumns), settings);

    Object.keys(tableColumnsFormats).forEach(function (key) {
      if (['', null].includes(tableColumnsFormats[key])) delete tableColumnsFormats[key];
    });

    _onUpdateFormatValue({
      formatTableColumns: tableColumnsFormats
    });
  };

  var onColumnNameUpdate = function onColumnNameUpdate(name, newName) {
    var columnsMap = _objectSpread({}, chartSettings.columnsNamesMapping);

    if (['', null].includes(newName)) delete columnsMap[name];else columnsMap[name] = newName;
    onUpdateColumnNamesMapping({
      columnsNamesMapping: columnsMap
    });
  };

  return React.createElement(React.Fragment, null, formattingNotAvailable ? React.createElement(BodyText, {
    variant: "body1"
  }, formattingNotAvailable) : React.createElement(MousePositionedTooltip, {
    isActive: !!formattingDisabled,
    tooltipPortal: modalContainer,
    tooltipTheme: "dark",
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body2",
        color: colors.white[500]
      }, formattingDisabled);
    }
  }, React.createElement(SettingsContainer, {
    isDisabled: !!formattingDisabled
  }, widgetType === 'table' ? React.createElement(FormatTableSettings, {
    columnsNamesMapping: chartSettings.columnsNamesMapping,
    onUpdateColumnName: onColumnNameUpdate,
    onUpdateFormatValue: onColumnFormatUpdate
  }) : React.createElement(FormatNumericSettings, {
    formatValue: chartSettings.formatValue,
    isDisabled: !!formattingDisabled || !!formattingNotAvailable,
    onUpdateFormatValue: function onUpdateFormatValue(settings) {
      return _onUpdateFormatValue({
        formatValue: settings
      });
    }
  }))));
};

export default FormatSettings;